import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';
import styles from './styles.module.scss';

const PlaceholderImage = ({ className, keepRatio, icon }) => {
	const placeHolderCx = cx(
		styles.Placeholder,
		{
			[styles.Placeholder__keepRatio]: keepRatio
		},
		className
	);

	return (
		<div className={placeHolderCx}>
			{icon ? <Icon icon={icon} className={styles.Placeholder_Icon} /> : null}
		</div>
	);
};

PlaceholderImage.propTypes = {
	className: PropTypes.string,
	keepRatio: PropTypes.bool,
	icon: PropTypes.string
};

PlaceholderImage.defaultProps = {
	keepRatio: false
};

export default PlaceholderImage;
